/**
 * A team's name drawn in its own color. A thin navy outline keeps pale colors
 * such as Khaki or Aquamarine legible on the white page, and dark ones read
 * on their own.
 */
export default function TeamName({ name, color, className = '' }: { name: string; color: string; className?: string }) {
  return (
    <span
      className={className}
      style={{ color, WebkitTextStroke: '2px #0a2240', paintOrder: 'stroke fill' }}
    >
      Team {name}
    </span>
  )
}
